module.exports = __webpack_public_path__ + "static/media/pic6.1565ed57.png";